import { Component, OnInit, Inject } from "@angular/core";
import { TruckOwnerService } from "../truck-owner.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-delete-account",
  templateUrl: "./delete-account.component.html",
  styleUrls: ["./delete-account.component.css"],
})
export class DeleteAccountComponent implements OnInit {
  deleteData: any;
  token: any;

  constructor(
    private services: TruckOwnerService,
    private router: Router,
    private snackBar: MatSnackBar,
    private matDialogRef: MatDialogRef<DeleteAccountComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.deleteData = data;
  }

  ngOnInit(): void {}
  backProfile() {
    this.matDialogRef.close();
  }
  deleteAccount() {
    const userType = "inactive";
    this.services
      .accountDelete(userType, this.deleteData, this.token)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.matDialogRef.close();
            this.router.navigateByUrl("/");
            sessionStorage.clear();
            this.snackBar.open(
              "Your account has been deleted successfully",
              "Success",
              {
                duration: 5000,
              }
            );
          }
        },
        (error) => {
          if (error.status == 403 || 401) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed || jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
